import { Component } from "react";
import { useNavigate } from "react-router-dom";

import ErrorAlert from "../components/layouts/ErrorAlert";
import InfoAlert from "../components/layouts/InfoAlert";

class BCModelPayement extends Component {
  typeClient() {
    const url = window.location.pathname.split("/")[1];

    if (url === "listBillAchat") {
      return <th>Fournisseur</th>;
    } else  if (url === "listBillVente") {
       return <th>Client</th>;
    }
  }
  valueTypeClient(bcom) {
    const url = window.location.pathname.split("/")[1];
    if (url === "listBillAchat") {
      return <td> {bcom.supplierMatricule}</td>;
    } else  if (url === "listBillVente") {
      return <td> {bcom.clientMatricule}</td>;
    }
  }

  urlPayement(bcom) {
    const url = window.location.pathname.split("/")[1];

    if (url === "listBillVente") {
      // this.props.navigate("/payerBillVente");


      return (
        <button
          type="submit"
          onClick={() => {
            localStorage.setItem("idBC", bcom.idDocument);
            this.props.navigate("/payerAvanceBCSell");
          }}
          className="btn btn-dark "
        >
          Payer
        </button>
      );
    } else if (url === "listBillAchat") {
      // this.props.navigate("/payerBill");
      return (
        <button
          type="submit"
          onClick={() => {
            localStorage.setItem("idBC", bcom.idDocument);
            this.props.navigate("/payerAvanceBC");
          }}
          className="btn btn-dark "
        >
          Payer
        </button>
      );

    }
  }
  // urlPayement(bcom) {
  //   if (localStorage.getItem("isIncome") === "ACHAT") {
  //     return (
  //       <button
  //         type="submit"
  //         onClick={() => {
  //           localStorage.setItem("idBC", bcom.idDocument);
  //           this.props.navigate("/payerAvanceBC");
  //         }}
  //         className="btn btn-dark "
  //       >
  //         Payer
  //       </button>
  //     );
  //   } else if (localStorage.getItem("isIncome") === "VENTE") {
  //     return (
  //       <button
  //         type="submit"
  //         onClick={() => {
  //           localStorage.setItem("idBC", bcom.idDocument);
  //           this.props.navigate("/payerAvanceBCSell");
  //         }}
  //         className="btn btn-dark "
  //       >
  //         Payer
  //       </button>
  //     );
  //   }
  // }
  priceTest(bcom) {
    if (bcom?.sellingPrice) {
      return <td> {bcom.sellingPrice} DNT </td>;
    } else if (bcom?.purchasingPrice) {
      return <td> {bcom.purchasingPrice} DNT </td>;
    }
  }
  render() {
    if (this.props.BC.length === 0) {
      return <InfoAlert message="Pas de bon de commande à afficher" />;
    } else {
      return (
        <div class="col-md-12">
          <div className="card card-dark">
            <div className="card-header">
              <h3 className="card-title">Les Bon de commandes</h3>
            </div>
            <div className="card-body">
              <table
                id="example1"
                className="table table-bordered table-striped"
              >
                <thead>
                  <tr>
                    <th>BDC</th>
                    <th>Designation</th>
                    {this.typeClient()}
                    <th>Total</th>
                    <th>Avance</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.BC.map((bcom) => (
                    <tr>
                      <td>{bcom.documentTitleAndReference}</td>
                      <td> {bcom.note}</td>
                      {this.valueTypeClient(bcom)}
                      {this.priceTest(bcom)}
                      {/* <td> {bcom.purchasingPrice}DNT </td> */}
                      <td> {this.urlPayement(bcom)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <br />
              <br />
            </div>
          </div>
        </div>
      );
    }
  }
}

export function BCModelPayementWithRoute(props) {
  const navigate = useNavigate();
  return <BCModelPayement navigate={navigate} BC={props.BC} />;
}
export default BCModelPayement;
